export class Seatmap {
  aircraft_file?: string;
	cabins: Cabin[];
	currency: any;
}

export type CabinClass = 'economy' | 'business';

export interface Cabin {
	/**
	* Y - Coach Economy
	* W - Coach Economy Premium
	* T - Coach Economy Discounted
	* S - Standard Class
	* C - Business Class
	* F - First Class
   	*/
	location: 'Y' | 'W' | 'T' | 'S' | 'C' | 'F';
	seatColumns: SeatColumn[];
	rows: CabinRow[];
	facilities: Facility[];
}

export class SeatColumn {
	index: string;
	status: 'W' | 'C' | 'A';
	class: string;
}

export class NewSeats {
	passengerIndex: number;
	seat: string;
	price: number;
}

export class PlaneWing {
	startRow: number;
	rowsCount: number;
}

export interface CabinRow {
	index: number;
	wing: boolean;
	empty: boolean;
	seatsByCode: PlaneSeat[];
}

export interface PlaneSeat {
	seatCode: string;
	row: string;
	column: string;
	available: boolean;
	missing: boolean;
	extraLegSpace: boolean;
	exit: boolean;
	chargeable: boolean;
	allowedInfant: boolean;
	allowedMedical: boolean;
	allowedUnnacompaniedMinor: boolean;
	suitableUnnacompaniedMinor: boolean;
	suitableChildren: boolean;
	handicappedFacilities: boolean;
	allowedBassinet: boolean;
	tableLeft: boolean;
	tableRight: boolean;
	orientation: 'R' | 'L'; // L->rotate seat to left or R-> to rotate seat to Right
	prices: any[];
	seatType?: string;
}

export interface Facility {
	rowLocation: any;
	// G - Galley, LA - Lavatory,, CL - Closet, E - Emergency Exit, D - Exit Door
	type: 'G' | 'LA' | 'CL' | 'E' | 'D' | 'WC';
	location: string;
}
